import styled from 'styled-components';

export const Col = styled.div`
  all: unset;

  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  all: unset;

  display: flex;
  flex-direction: row;
`;

export {};
